"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelEstimates = exports.LocationArrival = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const graphql_1 = require("../graphql");
const transformToDate_1 = require("../transformers/transformToDate");
let LocationArrival = class LocationArrival {
};
exports.LocationArrival = LocationArrival;
__decorate([
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], LocationArrival.prototype, "locationId", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LocationArrival.prototype, "locationName", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], LocationArrival.prototype, "timezone", void 0);
__decorate([
    (0, graphql_1.GField)(() => Date, { nullable: true }),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Object)
], LocationArrival.prototype, "arrivalAt", void 0);
__decorate([
    (0, graphql_1.GField)(() => Date, { nullable: true }),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Object)
], LocationArrival.prototype, "departureAt", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], LocationArrival.prototype, "distanceKm", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], LocationArrival.prototype, "travelTimeMinutes", void 0);
exports.LocationArrival = LocationArrival = __decorate([
    (0, graphql_1.GObjectType)("LocationArrival"),
    (0, graphql_1.GInputType)("LocationArrivalInput"),
    (0, class_transformer_1.Exclude)()
], LocationArrival);
/**
 * TravelEstimates encapsulates calculated details of travel.
 * This includes travel time, distance, arrival time of the whole trip, as well as a list of locations that
 * will be visited during the trip with estimated arrival times at each specified location.
 *
 * Main algorithm for calculation of travel time using travel data is located in:
 * `api/src/domain/content/travel-data/queries/calculate-travel-data/travel-data-algorithm.ts`
 *
 * Main util for calculating arrival times is located in:
 * `api/src/domain/content/travel-estimates/utils/calculate-arrival-times.ts`
 *
 * Legacy service that was the base of this class is located in `@legacy/services/CalculatorService.ts`
 */
let TravelEstimates = class TravelEstimates {
};
exports.TravelEstimates = TravelEstimates;
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], TravelEstimates.prototype, "travelTimeMinutes", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], TravelEstimates.prototype, "timeAtLocationsMinutes", void 0);
__decorate([
    (0, graphql_1.GField)(() => graphql_1.GFloat),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], TravelEstimates.prototype, "distanceKm", void 0);
__decorate([
    (0, graphql_1.GField)(() => Date, { nullable: true }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Object)
], TravelEstimates.prototype, "arrivalAt", void 0);
__decorate([
    (0, graphql_1.GField)(() => [LocationArrival]),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => LocationArrival),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], TravelEstimates.prototype, "locationArrivals", void 0);
__decorate([
    (0, graphql_1.GField)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TravelEstimates.prototype, "hash", void 0);
exports.TravelEstimates = TravelEstimates = __decorate([
    (0, graphql_1.GObjectType)("TravelEstimates"),
    (0, graphql_1.GInputType)("TravelEstimatesInput"),
    (0, class_transformer_1.Exclude)()
], TravelEstimates);
//# sourceMappingURL=TravelEstimates.js.map